import { ComposeViewState } from 'owa-mail-compose-store';
import { AttachmentWellViewState } from 'owa-attachment-well-data';
import {
    attachNounsTriggers,
    attachVerbsTriggers,
    fileNounsTriggers,
    fileVerbsTriggers,
} from './checkForForgottenAttachments.locstring.json';
import loc from 'owa-localize';

export default function checkForForgottenAttachments(viewState: ComposeViewState): boolean {
    const attachmentTriggers = (loc(attachNounsTriggers) || '')
        .split(',')
        .concat((loc(attachVerbsTriggers) || '').split(','));
    const filesTriggers = (loc(fileNounsTriggers) || '')
        .split(',')
        .concat((loc(fileVerbsTriggers) || '').split(','));

    let content = viewState.content.toLowerCase();

    //If the quoted body is appended to the content then we need to count the number of time the triggers apear in the quoted body and in the content and compare them
    //Else we just need to check if there are any trigers in the content.
    if (!viewState.useSmartResponse && viewState.quotedBody) {
        const quotedBody = viewState.quotedBody.toLowerCase();
        const attachmentTriggersInContent = countTriggers(content, attachmentTriggers);
        const attachmentTriggersInQuotedBody = countTriggers(quotedBody, attachmentTriggers);

        if (attachmentTriggersInContent > attachmentTriggersInQuotedBody) {
            return !checkForAttachments(viewState.attachmentWell);
        }

        const fileTriggersInContent = countTriggers(content, filesTriggers);
        const fileTriggersInQuotedBody = countTriggers(quotedBody, filesTriggers);

        if (fileTriggersInContent > fileTriggersInQuotedBody) {
            return !checkForFiles(viewState.attachmentWell);
        }
    } else {
        const hasAttachmentTriggers = attachmentTriggers.some(
            trigger => content.indexOf(trigger) > -1
        );

        const hasFilesTriggers = filesTriggers.some(trigger => content.indexOf(trigger) > -1);

        if (hasAttachmentTriggers) {
            return !checkForAttachments(viewState.attachmentWell);
        }

        if (hasFilesTriggers) {
            return !checkForFiles(viewState.attachmentWell);
        }
    }

    return false;
}

function checkForAttachments(attachmentWellViewState: AttachmentWellViewState): boolean {
    return (
        attachmentWellViewState.docViewAttachments.length > 0 ||
        attachmentWellViewState.imageViewAttachments.length > 0
    );
}

function checkForFiles(attachmentWellViewState: AttachmentWellViewState): boolean {
    return (
        checkForAttachments(attachmentWellViewState) ||
        attachmentWellViewState.sharingLinkIds.length > 0
    );
}

function countTriggers(message: string, triggers: string[]): number {
    return triggers.reduce((numberOfTriggers, trigger) => {
        const triggerRegex = new RegExp(`\\b${trigger}\\b`, 'g');
        numberOfTriggers += (message.match(triggerRegex) || []).length;
        return numberOfTriggers;
    }, 0);
}
